export const GUARDRAILS_STAMP = "POLICY ENGINE";

export const GUARDRAILS_SCAN_PILLS = [
  { value: "100%", label: "Policy compliance" },
  { value: "NO", label: "False service promises" },
  { value: "ZERO", label: "Unfit lead waste" },
];

export const GUARDRAILS_HEADLINE = {
  lead: "Precision Guardrails:",
  accent: "Your Pricing and Services, Always Accurate",
};

export const GUARDRAILS_SUBHEAD =
  "Never worry about your Digital assistant promising a service you don't offer or quoting a final price without seeing the roof.";

export const GUARDRAILS_INPUT = "Inbound lead request";

export const GUARDRAILS_OUTPUT = "Qualified · policy-compliant lead";

export const GUARDRAILS_GATES = [
  {
    id: "services",
    tag: "GATE 01",
    label: "SERVICE FILTER",
    headline: "Only discusses what you actually provide",
    allow: "Tile reroof, leak repair, free inspections",
    block: "Asbestos, solar, out-of-scope jobs — politely declined",
  },
  {
    id: "pricing",
    tag: "GATE 02",
    label: "PRICING CAP",
    headline: "Ballpark ranges — never a final quote",
    allow: "Price-per-square estimates to qualify budget",
    block: "Final price before your estimator is on the roof",
    highlight: true,
  },
  {
    id: "fit",
    tag: "GATE 03",
    label: "LEAD FIT",
    headline: "Zero-waste qualification",
    allow: "Residential up to 2 storeys in your service radius",
    block: "3-storey commercial complexes you don't take",
  },
];

export const GUARDRAILS_PAYOFF =
  "Every reply runs against your live rules — services, pricing policy, and lead fit — so your reputation stays protected.";
